import { Component, ViewChild } from '@angular/core';

import {
    Expense, Unit, Investor, Category
} from './../../../../../_models';
import { MoneyListComponent } from '../../common/list';
import { LiveSearchSelectComponent } from './../../../../../shared/live-search-select';
import { DatePickerComponent } from './../../../../../shared/date-picker';

@Component({
    selector: 'app-expense-list',
    templateUrl: './expense-list.component.html',
    styleUrls: ['../../common/list/money-list.component.scss']
})
export class ExpenseListComponent {

    @ViewChild(MoneyListComponent) money: MoneyListComponent;
    @ViewChild('investor') investorFilter: LiveSearchSelectComponent;
    @ViewChild('unit') unitFilter: LiveSearchSelectComponent;
    @ViewChild('category') categoryFilter: LiveSearchSelectComponent;
    @ViewChild('startDate') startDate: DatePickerComponent;
    @ViewChild('endDate') endDate: DatePickerComponent;
    sort: any = {};
    totalText = 'Total de egresos';
    widgetClass = 'm--bg-danger';
    endPoint = '/expenses/';
    concept: string;
    fromAmount: string;
    toAmount: string;
    investorTexts = {
        label: "Propietarios",
        notFound: "Propietario no registrado",
        loading: "Cargando propietarios...",
        none: "Ningun Propietario"
    }
    unitTexts = {
        label: "Unidades",
        notFound: "Unidad no registrada",
        loading: "Cargando unidades...",
        none: "Ninguna unidad"
    }
    fromTexts = {
        label: "Desde fecha",
        placeholder: ""
    };
    toTexts = {
        label: "Hasta fecha",
        placeholder: ""
    };

    constructor(
        private categoryModel: Category,
        private expense: Expense,
        private investorModel: Investor,
        private unitModel: Unit) {
        this.getList();
    }

    buildSearchString() {
        let result = ``;
        // if (!this.investorModel.empty()) {
        //     result += `&investor_id=${this.investorModel.item.id}`;
        // }
        // if (!this.unitModel.empty()) {
        //     result += `&unit_id=${this.unitModel.item.id}`;
        // }
        if (this.concept) {
            result += `&concept=${this.concept}`;
        }
        if (this.fromAmount) {
            result += `&fromAmount=${this.fromAmount}`;
        }
        if (this.toAmount) {
            result += `&toAmount=${this.toAmount}`;
        }
        if (!this.categoryModel.empty()) {
            result += `&category_id=${this.categoryModel.item.id}`;
        }
        if (!this.startDate.empty()) {
            result += `&start_date=${this.startDate.value.string}`;
        }
        if (!this.endDate.empty()) {
            result += `&end_date=${this.endDate.value.string}`;
        }
        if (this.sort.dir && this.sort.column) {
            result += `&sortDir=${this.sort.dir}&sortBy=${this.sort.column}`;
        }
        return result;
    }
    search() {
        this.expense.search(this.buildSearchString()).subscribe(expenses => {
            this.money.list = expenses;
        });
    }
    clear() {
        // this.investorFilter.clear();
        // this.unitFilter.clear();
        this.concept = null;
        this.fromAmount = null;
        this.toAmount = null;
        this.categoryFilter.clear();
        this.startDate.clear();
        this.endDate.clear();
        this.getList();
    }
    deleteEl(el) {
        this.expense.delete(el).subscribe(response => {
            this.getList();
        });
    }
    getList() {
        this.expense.getAll().subscribe(expenses => {
            this.money.list = expenses;
        });
    }
    onSort(sort) {
        this.sort = sort;
        this.search();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/expenses/expense-list/expense-list.component.ts